import React from 'react';
import { mapPlantDesignHolderSummary } from 'plantDesign/utils/PlantDesignSummaryFormatHelper';
import styles from '../PlantDesignReview.module.scss';

export const HolderDetailsReview = (props) => {
  const { holderDetails = {}, applicantDetails = {} } = props;

  const formattedHolderDetails = mapPlantDesignHolderSummary(holderDetails, applicantDetails);

  return formattedHolderDetails.map((prop) => {
    return (
      prop.value && (
        <div key={prop.text}>
          <div className={styles.summaryLabel}>{prop.text}</div>
          <div className={styles.summaryValue}>{prop.value}</div>
          {prop.value2 && <div className={styles.summaryValue}>{prop.value2}</div>}
        </div>
      )
    );
  });
};
